import { map, tileLayer, marker } from 'leaflet';
import CalendarPopup from './CalendarPopup';

document.addEventListener('DOMContentLoaded', () => {
  setupAddToCalendarBtn();
  setupEventMap();
});

const setupAddToCalendarBtn = () => {
  const btnEl = document.querySelector("#add-to-cal-btn");
  const popupEl = document.querySelector("#add-to-cal-popup");
  if (!btnEl || !popupEl) { return; }

  new CalendarPopup(btnEl, popupEl);
}

/**
 * Setup the venue map shown using leaflet
 */
const setupEventMap = () => {
  const eventMapEl = document.querySelector('#map');
  if (!eventMapEl) { return; }

  const latLng = [eventMapEl.dataset.lat, eventMapEl.dataset.lng];

  // Load the event map
  const eventMap = map(eventMapEl, {
    center: latLng,
    zoom: 17
  });

  // Add the tile layer with proper attributions to OpenStreetMap
  const layer = tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  });
  layer.addTo(eventMap);

  // Mark the spot!
  marker(latLng).addTo(eventMap);

  // Disable zoom on scrollWheel
  eventMap.scrollWheelZoom.disable();
}

$(document).ready(function(){
  $('#new_cart_item select').on('change', function(){
    if (submitTag){
      var ticketQuantity = $(this).val();
      window.dataLayer.push({
        event: 'ticket_quantity_selected',
        ticket_quantity: ticketQuantity
      });
    }
  });
  $('#btn-buy-tickets').on('click', function(){
    if (submitTag){
      var ticketQuantity = 0;
      $('#new_cart_item select').each((x, ele)=>{
        ticketQuantity += +$(ele).val();
      });
      window.dataLayer.push({
        event: 'booking_start',
        ticket_quantity: ticketQuantity,
        booking_timestamp: new Date().toISOString()
      });
    }
  });
});